"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var property_1 = require("./property");
var core_1 = require("../../core");
var type_checker_1 = require("../type-checker");
var ValueProperty = (function (_super) {
    __extends(ValueProperty, _super);
    function ValueProperty(propertyName, type) {
        var _this = _super.call(this, propertyName) || this;
        _this.type = type;
        return _this;
    }
    ValueProperty.prototype.initializePrototype = function (proto) {
        mobx_1.observable.ref(proto, this.name, { value: undefined });
    };
    ValueProperty.prototype.initialize = function (targetInstance, snapshot) {
        targetInstance[this.name] = this.type.create(snapshot[this.name]);
    };
    ValueProperty.prototype.willChange = function (change) {
        var node = core_1.getMSTAdministration(change.object);
        change.newValue = node.reconcileChildren(this.type, [change.object[change.name]], [change.newValue], [change.name])[0];
        return change;
    };
    ValueProperty.prototype.didChange = function (change) {
        var node = core_1.getMSTAdministration(change.object);
        node.emitPatch({
            op: "replace",
            path: core_1.escapeJsonPath(this.name),
            value: core_1.valueToSnapshot(change.newValue)
        }, node);
    };
    ValueProperty.prototype.serialize = function (instance, snapshot) {
        snapshot[this.name] = core_1.valueToSnapshot(instance[this.name]);
    };
    ValueProperty.prototype.deserialize = function (instance, snapshot) {
        var _this = this;
        core_1.maybeMST(instance[this.name], function (propertyNode) { propertyNode.applySnapshot(snapshot[_this.name]); }, function () { instance[_this.name] = snapshot[_this.name]; });
    };
    ValueProperty.prototype.validate = function (snapshot, context) {
        return this.type.validate(snapshot[this.name], type_checker_1.getContextForPath(context, this.name, this.type));
    };
    return ValueProperty;
}(property_1.Property));
exports.ValueProperty = ValueProperty;
//# sourceMappingURL=value-property.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mobx-state-tree/lib/types/property-types/value-property.js
// module id = 223
// module chunks = 0